import { atom } from "jotai";

type TZoomIntegrationState  = {
  zoomLicesePermisson: boolean;
  googleMessageView: boolean;
  zoomMessageView: boolean;
  zoomPermissionErrorView: boolean;
  eventsRefetchingWithPubnub: boolean;
  eventsRefetching: boolean;
  meetingListRefetching: boolean;
  errorMessage: string | null;
};

export const zoomIntegrationStateAtom = atom<TZoomIntegrationState>({
  googleMessageView: false,
  zoomMessageView: false,
  zoomPermissionErrorView: false,
  eventsRefetchingWithPubnub: false,
  eventsRefetching: false,
  meetingListRefetching: false,
  zoomLicesePermisson:false,
  errorMessage:null
});
